module.exports = __webpack_public_path__ + "static/media/Small Clown.d98a1a99.jpg";